module.exports = __webpack_public_path__ + "static/media/Grandstander-Black.1551fe3f.ttf";